import { queryOptions } from '@tanstack/react-query'
import { ApiError, customerRequest } from '@/shared/api'
import {
  type CustomerProfile,
  CustomerProfileResponseSchema,
  customerProfileFrom,
} from '../model/types'

export const customerSessionKeys = {
  me: ['customer-session', 'me'] as const,
}

// 401 на /auth/customer/me = «сессии заказчика нет» → null, не ошибка: экраны
// /customer/* и /login разводят это сами (форма входа против «сессия истекла»).
// Профиль перечитывается из БД, поэтому блокировка аккаунта видна сразу.
export const customerSessionQueryOptions = queryOptions({
  queryKey: customerSessionKeys.me,
  queryFn: async (): Promise<CustomerProfile | null> => {
    try {
      const body = await customerRequest<unknown>({ method: 'GET', path: '/auth/customer/me' })
      return customerProfileFrom(CustomerProfileResponseSchema.parse(body).data)
    } catch (error) {
      if (error instanceof ApiError && error.isUnauthorized) return null
      throw error
    }
  },
  staleTime: 60_000,
  retry: false,
})
